import SubaruVisualTopicSelector from '@/components/themes/subaru/publications/visualTopicSelector'
import {
  getTagToResourceKeysEng,
  createNotAvailablePublicationFactory,
  getContentGroupedByPartTags
} from '@/utils/overview/helpers'
import useTranslation from '@/hooks/useTranslation'
import { useMemo, useCallback } from 'react'
import { useRouter } from 'next/router'
import { generalHelpers } from '@tweddle-se-team/common/helpers'

const { renamePubType } = generalHelpers

function VisualSearch({
  hotspots,
  baseDFOMEngPublication,
  digitalFirstOwnerManual,
  publicationTypes,
  publications,
  publicationRowClassName,
  publicationListClassName,
  openVideoModal,
  updateQueryParams,
  noPublications: noPublicationsComponent
}) {
  const router = useRouter()
  const { query } = router
  const selectedView = query.selectedView || 'Front'
  const selectedPart = query.selectedPart || null
  const selectedTopicType = query.selectedTopicType || 'all'
  const tagToResourceKeysEngMap = getTagToResourceKeysEng(baseDFOMEngPublication)

  const t = useTranslation()

  const onSelectView = useCallback(
    ({ selectedView }) => {
      updateQueryParams({ selectedView })
    },
    [updateQueryParams]
  )

  const onHotSpotClick = useCallback(
    value => {
      updateQueryParams({ selectedPart: value })
    },
    [updateQueryParams]
  )
  const onSelectTopicType = useCallback(
    ({ selectedTopicType }) => {
      updateQueryParams({ selectedTopicType })
    },
    [updateQueryParams]
  )

  const onTopicSelect = topic => {
    switch (topic.type) {
      case 'topic': {
        router.push({
          pathname: '/content',
          query: {
            id: digitalFirstOwnerManual.contents.ditaId,
            topicId: topic.persistentId,
            publicationType: digitalFirstOwnerManual.publicationType
          }
        })
        break
      }
      case 'video': {
        openVideoModal(topic.title, topic.content)
        break
      }
    }
  }

  // getContentGroupedByPartTags needs publication title and createNotAvailablePublication
  const createNotAvailablePublication = useMemo(
    () => createNotAvailablePublicationFactory(publicationTypes, t, renamePubType),
    [publicationTypes, t]
  )
  const publicationToHotspot = publications.map(publication => ({
    ...publication,
    title: t(renamePubType(publicationTypes, publication.publicationType, 'label')),
    type: 'publication'
  }))

  const partsGroupedByView = useMemo(
    () =>
      getContentGroupedByPartTags({
        hotspotMapping: hotspots,
        selectedView,
        tagToResourceKeysEngMap,
        publicationTopics: digitalFirstOwnerManual?.topics || [],
        publicationToHotspot,
        createNotAvailablePublication
      }),
    [
      hotspots,
      selectedView,
      tagToResourceKeysEngMap,
      digitalFirstOwnerManual,
      publicationToHotspot,
      createNotAvailablePublication
    ]
  )
  if (!digitalFirstOwnerManual) return noPublicationsComponent

  return (
    <SubaruVisualTopicSelector
      selectedView={selectedView}
      onSelectView={onSelectView}
      hotSpotMapping={hotspots}
      onHotSpotClick={onHotSpotClick}
      partsGroupedByView={partsGroupedByView}
      selectedPart={selectedPart}
      selectedTopicType={selectedTopicType}
      onSelectTopicType={onSelectTopicType}
      onTopicSelect={onTopicSelect}
      publicationRowClassName={publicationRowClassName}
      publicationListClassName={publicationListClassName}
    />
  )
}

export default VisualSearch
